<template><svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.000000 512.000000">
<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
<path d="M594 4955 c-207 -45 -385 -225 -430 -434 -11 -55 -14 -373 -14 -1957
0 -1298 3 -1909 11 -1950 17 -99 82 -219 158 -295 78 -78 198 -142 301 -159
45 -8 459 -10 1375 -8 l1310 3 66 22 c130 45 258 150 319 264 57 107 63 133
69 308 l6 164 90 18 c367 74 674 313 840 653 345 706 -71 1545 -845 1704 l-85
17 -5 335 c-5 316 -6 337 -25 362 -33 44 -1084 939 -1121 954 -48 20 -1927 19
-2020 -1z m1816 -684 c0 -396 0 -398 23 -431 12 -19 38 -43 57 -54 34 -20 52
-21 503 -24 l467 -3 0 -228 0 -229 -67 -12 c-308 -57 -604 -257 -778 -524
-311 -476 -246 -1107 155 -1506 103 -103 206 -175 343 -240 96 -46 271 -100
323 -100 l24 0 0 -132 c0 -119 -3 -139 -24 -184 -13 -28 -43 -67 -67 -87 -83
-71 -2 -68 -1435 -65 l-1289 3 -41 22 c-53 28 -99 74 -127 127 l-22 41 0 1915
0 1915 22 41 c39 73 105 127 178 145 17 4 418 7 893 8 l862 1 0 -399z m560 -1
c118 -101 219 -187 225 -192 5 -4 -102 -8 -238 -8 l-247 0 0 212 0 211 23 -20
c12 -11 119 -102 237 -203z m879 -1290 c326 -93 566 -344 648 -676 25 -104 23
-294 -6 -409 -82 -337 -353 -598 -695 -671 -91 -19 -271 -19 -363 0 -338 72
-603 324 -694 661 -32 116 -32 326 0 444 92 344 346 585 702 666 93 21 310 13
408 -15z"/>
<path d="M976 3441 c-91 -60 -94 -188 -5 -252 l34 -24 802 0 c798 0 802 0 830
21 94 70 96 190 4 251 l-34 23 -801 0 c-768 0 -802 -1 -830 -19z"/>
<path d="M980 2838 c-54 -37 -74 -72 -74 -128 0 -54 18 -87 68 -124 27 -20 40
-21 525 -24 l497 -3 34 23 c75 52 96 118 60 193 -15 32 -34 52 -61 65 -36 19
-61 20 -527 20 l-489 0 -33 -22z"/>
<path d="M994 2246 c-110 -49 -118 -206 -14 -265 37 -21 49 -21 527 -21 555 0
536 -3 581 81 38 71 20 140 -52 193 -27 20 -40 21 -519 23 -399 2 -498 0 -523
-11z"/>
<path d="M990 1638 c-105 -54 -115 -196 -17 -257 34 -21 44 -21 531 -21 543 0
533 -1 575 58 48 68 34 156 -35 208 l-37 29 -486 3 -486 3 -45 -23z"/>
<path d="M3540 2688 c-71 -49 -75 -61 -78 -254 l-4 -174 -159 0 c-112 0 -169
-4 -192 -14 -43 -18 -85 -68 -93 -112 -9 -48 19 -118 59 -146 30 -21 44 -23
209 -26 l176 -3 4 -172 c3 -156 5 -175 25 -207 30 -48 71 -70 132 -70 46 0 56
4 94 39 l42 40 5 183 5 183 182 5 182 5 36 35 c61 59 67 131 17 199 -40 54
-71 61 -257 61 l-165 0 0 174 c0 163 -1 175 -23 207 -44 67 -135 88 -197 47z"/>
</g>
</svg>
</template>